import { defineMessages } from 'react-intl';

export default defineMessages({
  title: { defaultMessage: 'Deposit APR' },
  graphDotName: { defaultMessage: 'APR' },
});
